import { Component } from '@angular/core';

@Component({
  selector: 'sk-not-found',
  standalone: false,
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css',
})
export class NotFoundComponent {}
